// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import React from 'react'
import { MaintenanceWindowMessageContainer } from './styles'
import databaseManagementBg from 'images/maintenance-bg.jpg'

const idRoot = 'maintenance-window-active-message'

const MaintenanceWindowActiveMessage = () => (
  <MaintenanceWindowMessageContainer bgImage={databaseManagementBg}>
    <div className={'justify-content-center padding-1'}>
      <h1
        className={'heading-font margin-bottom-half'}
        id={`${idRoot}-heading`}>
        {'Comsearch Connect is Unavailable.'}
      </h1>
      <p id={`${idRoot}-message`}>
        <span>{'Due to critical data processes, the website is unavailable from '}</span>
        <strong>{'1 AM'}</strong>
        <span>{' to '}</span>
        <strong>{'5 AM'}</strong>
        <span>{' Eastern.'}</span>
      </p>
    </div>
  </MaintenanceWindowMessageContainer>
)

export default MaintenanceWindowActiveMessage
